import React, { ReactNode } from 'react'
import { Link } from '@afterpaytouch/core'
import { Trans } from '../../utils/convergence'

type TranslateDonationKey = (key: string, options?: { amount: string }) => string

interface DonationCampaignContentSelectorInput {
  amount: string
  t: TranslateDonationKey
  termsUrl: string
  strong: React.ReactElement
}

export interface DonationCampaignSelectionInput extends DonationCampaignContentSelectorInput {
  campaignId?: string
}

export interface DonationCampaignContentViewModel {
  body: ReactNode
  title: string
}

type DonationCampaignContentSelector = (input: DonationCampaignContentSelectorInput) => DonationCampaignContentViewModel

export const DONATION_CAMPAIGN_IDS = [
  'BEFEB22',
  'CANCERCHICKSFEB26',
  'CANCERCHICKSOCT25',
  'CANCERCHICKSOCT26',
  'DRESSSUCCESSJUN23',
  'DRESSSUCCESSMAR22',
  'DRESSSUCCESSMAR24',
  'DRESSSUCCESSMAR25',
  'DRESSSUCCESSMAR26',
  'FEJUN22',
  'FEMAR22',
  'FEMAR23',
  'GLOBALSISTERSAUG23',
  'GLOBALSISTERSMAR22',
  'GLOBALSISTERSMAR23',
  'GLOBALSISTERSMAR24',
  'GLOBALSISTERSMAR25',
  'GLOBALSISTERSMAR26',
  'GSMAR22PART2',
  'REDCROSSMAR23',
  'THREADTOGETHER21',
  'THREADTOGETHERAPR24',
  'THREADTOGETHERAUAUG',
  'THREADTOGETHERAUG23',
  'THREADTOGETHERAUG24',
  'THREADTOGETHERAUG25',
  'THREADTOGETHERAUG26',
  'THREADTOGETHERAUNOV',
  'THREADTOGETHERDEC23',
  'THREADTOGETHERJAN25',
  'THREADTOGETHERMAY23',
  'THREADTOGETHERMAY25',
  'THREADTOGETHERMAY26',
  'THREADTOGETHERNOV24',
  'THREADTOGETHERNOV25',
  'THREADTOGETHERNOV26',
  'TTFLOODMAR22',
] as const

export type DonationCampaignId = (typeof DONATION_CAMPAIGN_IDS)[number]

const DONATION_CAMPAIGN_ID_SET: ReadonlySet<string> = new Set(DONATION_CAMPAIGN_IDS)

export const isDonationCampaignId = (campaignId: string): campaignId is DonationCampaignId => DONATION_CAMPAIGN_ID_SET.has(campaignId)

const DONATION_CAMPAIGN_CONTENT_SELECTORS: Record<DonationCampaignId, DonationCampaignContentSelector> = {
  BEFEB22: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:BEFEB22:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:BEFEB22:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  CANCERCHICKSFEB26: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:CANCERCHICKSFEB26:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:CANCERCHICKSFEB26:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  CANCERCHICKSOCT25: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:CANCERCHICKSOCT25:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:CANCERCHICKSOCT25:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  CANCERCHICKSOCT26: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:CANCERCHICKSOCT26:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:CANCERCHICKSOCT26:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  DRESSSUCCESSJUN23: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:DRESSSUCCESSJUN23:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:DRESSSUCCESSJUN23:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  DRESSSUCCESSMAR22: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:DRESSSUCCESSMAR22:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:DRESSSUCCESSMAR22:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  DRESSSUCCESSMAR24: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:DRESSSUCCESSMAR24:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:DRESSSUCCESSMAR24:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  DRESSSUCCESSMAR25: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:DRESSSUCCESSMAR25:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:DRESSSUCCESSMAR25:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  DRESSSUCCESSMAR26: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:DRESSSUCCESSMAR26:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:DRESSSUCCESSMAR26:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  FEJUN22: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:FEJUN22:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:FEJUN22:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  FEMAR22: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:FEMAR22:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:FEMAR22:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  FEMAR23: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:FEMAR23:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:FEMAR23:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  GLOBALSISTERSAUG23: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:GLOBALSISTERSAUG23:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:GLOBALSISTERSAUG23:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  GLOBALSISTERSMAR22: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:GLOBALSISTERSMAR22:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:GLOBALSISTERSMAR22:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  GLOBALSISTERSMAR23: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:GLOBALSISTERSMAR23:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:GLOBALSISTERSMAR23:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  GLOBALSISTERSMAR24: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:GLOBALSISTERSMAR24:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:GLOBALSISTERSMAR24:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  GLOBALSISTERSMAR25: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:GLOBALSISTERSMAR25:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:GLOBALSISTERSMAR25:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  GLOBALSISTERSMAR26: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:GLOBALSISTERSMAR26:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:GLOBALSISTERSMAR26:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  GSMAR22PART2: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:GSMAR22PART2:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:GSMAR22PART2:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  REDCROSSMAR23: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:REDCROSSMAR23:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:REDCROSSMAR23:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHER21: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHER21:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHER21:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERAPR24: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERAPR24:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERAPR24:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERAUAUG: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERAUAUG:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERAUAUG:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERAUG23: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERAUG23:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERAUG23:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERAUG24: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERAUG24:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERAUG24:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERAUG25: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERAUG25:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERAUG25:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERAUG26: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERAUG26:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERAUG26:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERAUNOV: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERAUNOV:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERAUNOV:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERDEC23: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERDEC23:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERDEC23:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERJAN25: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERJAN25:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERJAN25:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERMAY23: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERMAY23:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERMAY23:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERMAY25: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERMAY25:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERMAY25:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERMAY26: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERMAY26:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERMAY26:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERNOV24: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERNOV24:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERNOV24:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERNOV25: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERNOV25:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERNOV25:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  THREADTOGETHERNOV26: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:THREADTOGETHERNOV26:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:THREADTOGETHERNOV26:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
  TTFLOODMAR22: ({ amount, t, termsUrl, strong }) => ({
    title: t('donation:TTFLOODMAR22:title', { amount }),
    body: (
      <Trans
        i18nKey='donation:TTFLOODMAR22:body'
        tOptions={{ amount }}
        components={{
          l: <Link kind='Underline' href={termsUrl} target='_blank' />,
          strong,
        }}
      />
    ),
  }),
}

export const selectDonationCampaignContent = (input: DonationCampaignSelectionInput): DonationCampaignContentViewModel | null => {
  const { campaignId, ...campaignContentSelectorInput } = input

  if (campaignId == null || campaignId.length === 0) {
    return null
  }

  if (!isDonationCampaignId(campaignId)) {
    return null
  }

  return DONATION_CAMPAIGN_CONTENT_SELECTORS[campaignId](campaignContentSelectorInput)
}
